(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_slide-video"] && !Shopify.designMode) return;
  try {
    (function () {
  'use strict';

  if (window.__videoMuteToggleInitialized) return;
  window.__videoMuteToggleInitialized = true;

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-video-mute-toggle]');
    if (!button) return;

    var wrapper = button.closest('.video-background');
    var video = wrapper && wrapper.querySelector('video');
    if (!video) return;

    video.muted = !video.muted;

    var isMuted = video.muted;
    button.classList.toggle('is-unmuted', !isMuted);
    button.setAttribute('aria-pressed', String(!isMuted));
    button.setAttribute(
      'aria-label',
      isMuted ? button.getAttribute('data-unmute-label') : button.getAttribute('data-mute-label')
    );
  });
})();
  } catch(e) { console.error(e); }
})();

})();
